import { render, staticRenderFns } from "./CreateModelConfiguration.vue?vue&type=template&id=336398a0&"
import script from "./CreateModelConfiguration.vue?vue&type=script&lang=js&"
export * from "./CreateModelConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports